<div class="ui container charts-container">
    <div class="left-column">
        <div class="chart-container">
            <div class="chart-header">
                <h3>Total Failed Login Attempts Alert</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>

        <div class="chart-container">
            <div class="chart-header">
                <h3>Total Geofence Violations Alert</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>

        <div class="chart-container">
            <div class="chart-header">
                <h3>Total Blocked IP Addresses Alert</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>
    </div>
    <div class="right-column">
        <div class="chart-container">
            <div class="chart-header">
                <h3>Total File Upload Anomalies Alert</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>
        <div class="chart-container">
            <div class="chart-header">
                <h3>Total Malicious Requests Recieved Alert</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>

        <div class="chart-container">
            <div class="chart-header">
                <h3>Total Rate Limit Exceeded by Users Alert</h3>
            </div>
            <div class="chart-content">

            </div>
        </div>
    </div>
</div>